import resetEnrollment from 'thunks/resetEnrollment';

import { clearAllLocalDataAndCookies } from 'utils/storage/storageHelper';

/**
 * Needed for native handoff work:
 *
 * If we detect that user has started a new enrollment webview session,
 * we set 'NEED_HARD_RESET' as true in storage so we can force a hard session reset
 * later on in RenderFormRoutes.js
 * */
const clearSessionForNative = () => dispatch => {
  clearAllLocalDataAndCookies();
  dispatch(resetEnrollment());
};

export default clearSessionForNative;
